import { SuppliersProvider } from 'Context/SuppliersContext';
import { Supplier } from './Supplier';
export const SingleSupplier = () => {
  return (
    <SuppliersProvider>
      <Supplier />
    </SuppliersProvider>
  );
};
